module.exports = __webpack_public_path__ + "static/media/Header-Image-Template.26f4f877.jpg";